import React from "react";
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterSection() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }];
  return <footer id="סיומת-האתר" className="dark bg-background text-foreground pt-20 pb-10 border-t border-border/10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/smoke_and_go_logo.png" alt="SMOKE & GO" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              SMOKE & GO מציעה חווית בשרים מעושנים איכותית ומודרנית. 
              אנו מתמחים בנתחים מובחרים, תיבול ייחודי ושירות מהיר, 
              הכל באווירה יוקרתית ומזמינה.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-wide text-foreground">קישורים מהירים</h3>
            <MenuProvider menu_id="18" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-wide text-foreground">עקבו אחרינו</h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => <Link key={i} data-index={i} to={social.href} newTab className="bg-secondary/50 p-3 rounded-full text-muted-foreground hover:bg-primary hover:text-white transition-all duration-300 group" aria-label={social.label}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
            <p className="text-sm text-muted-foreground">
              הצטרפו לקהילה שלנו ברשתות החברתיות והישארו מעודכנים במבצעים חדשים.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-wide text-foreground">צרו איתנו קשר</h3>
            <ul className="space-y-4 text-sm text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>קדש 18, אשקלון, ישראל</span>
              </li>
              <li className="flex items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-5 text-primary shrink-0" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:enff8y" data-ast-start="3792" data-ast-end="3842"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg><span dir="ltr" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:hi22xo" data-ast-start="3859" data-ast-end="3896">+972-50-2770606</span></li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-primary shrink-0" />
                <span>sharondor5@gmail.com</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="size-5 text-primary shrink-0 mt-0.5" />
                <span>ראשון-שבת: 10:00-22:00</span>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="my-10 bg-border/20" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/60">
          <p>© 2025 SMOKE &amp; GO. כל הזכויות שמורות.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">תנאי שימוש</Link>
            <Link to="#" className="hover:text-foreground transition-colors">מדיניות פרטיות</Link>
            <Link to="#" className="hover:text-foreground transition-colors">הצהרת נגישות</Link>
          </div>
        </div>
      </div>
    </footer>;
}